import React, { Component, Fragment } from 'react';
import axios from 'axios';
import BroadCastVideo from './shareholder/BroadCastVideo';
import UserLogin from './login/UserLogin';
import UserRegister from './login/UserRegister';
import AllSlide from "./shareholder/AllSlide";
import Speaker from "./shareholder/Speaker";
import Comment from './shareholder/Comment';
import Echo from 'laravel-echo';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
window.io = require('socket.io-client');

class BeforeLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shareHolderSlide: null,
            speaker: [],
            comments: [],
            allSlide: [],  
            changeBigSlider : null,
            chatBlockShow: localStorage.programQuestionStatus,
            videoPlayFrom: 0,
            shareHolderSlide2:null,
            bigImageClick: null,
            renderSlider: true,
            sliderResponsive:{
                0: {
                    items: 2,
                },
                450: {
                    items: 3,
                },
                600: {
                    items: 4,
                },
                1000: {
                    items: 6,
                },
                1200: {
                    items: 8,
                },

            } 
            
        }
        this.key = 'YUIKjuiKJIolkqUiWFDIE5LALyuiolSDwsDXCvBWzMq2gwWBvJcS8kl7RTYuJHTyuj';
    }
    
    componentDidMount() {
        {localStorage.noticeStatus == 1 &&
            document.getElementById('noticeOpen').click();
        }
        this.echo = new Echo({
            broadcaster: 'socket.io',
            host: 'https://edechoserveraws.comjagat.org',
            // host: 'https://echoservered.comjagat.org',
            // host: 'http://localhost:6001',
            // host: 'https://test-echoserver.comjagat.org',
            auth: {
                headers: {  
                    'key': this.key,
                    'access-token': localStorage.token
                }
            }
        });
        const echo = this.echo;        
        
        //this event fire when new comment approve by moderator
        echo.private('approved-comment-' + localStorage.programId)
        .listen('.approved-comment-event', (commentData) => {
            console.log(commentData);
            this.state.comments.push(commentData);
            this.setState({
                comments: this.state.comments,
                renderSlider: false
            });   
            let elem = document.getElementById('chatbox-body');
            if(elem !== null){
                elem.scrollTop = elem.scrollHeight;
            }
        });

        echo.private(`reload-program-${localStorage.programId}`)
        .listen('.reload-program-event', (program_id) => {
            window.location.reload();
        });

        echo.private(`active-slider-${localStorage.programId}`)
        .listen('.active-slider-event', (slide) => {
            this.setState({
                shareHolderSlide: 'data:image/png;base64,'+slide.image,
                renderSlider: false
            });
        });

        axios({
            method: 'post',
            url: `${localStorage.apiHost}/big-slider`,
            headers: {
                'key': this.key,
                // 'access-token': localStorage.token
            },
            data: {
                'program-id': localStorage.programId
            }
        }).then(response => {
            if (response.data.status === 200) {
                   
                this.setState({
                    shareHolderSlide: 'data:image/png;base64,'+response.data.image
                });
            }
        });

        axios({
            method: 'post',
            url: `${localStorage.apiHost}/all-speaker`,
            headers: {
                'key': this.key
            },
            data: {
                'program-id': localStorage.programId
            }
        }).then(response => {
            if (response.data.status === 200) {
                response.data[0].forEach(speaker => {
                    this.state.speaker.push(speaker);
                })
                this.setState({speaker: this.state.speaker});
            }
        });
        
        axios({
            method: 'post',
            url: `${localStorage.apiHost}/all-slider`,
            headers: {
                'key': this.key,
                // 'access-token': localStorage.token
            },
            data: {
                'program-id': localStorage.programId
            }
        }).then(response => {
            if (response.data.status === 200) {
                response.data[0].forEach((allSlide,index) => {                    
                    this.state.allSlide.push(allSlide);
                    this.index = index;
                })
                this.setState({allSlide: this.state.allSlide});
            }
        });

        axios({
            method: 'post',
            url: `${localStorage.apiHost}/all-comment`,
            headers: {
                'key': this.key,
                'access-token': localStorage.token
            },
            data: {
                'program-id': localStorage.programId
            }
        }).then(response => {
            if (response.data.status === 200) {
                response.data[0].forEach(comment => {
                    this.state.comments.push(comment);
                })
                this.setState({comments: this.state.comments});
                let elem = document.getElementById('chatbox-body');
                if(elem !== null){
                    elem.scrollTop = elem.scrollHeight;
                }
            }
        })   

    }

    OnChangeBigSlider=(event)=>{
        
        if(localStorage.programStatus == 3){
            
            // document.getElementById('BigImage').src = event.target.src;
            // document.getElementById('BigImageView').src = event.target.src;

            let second = (event.target.attributes.getNamedItem('second').value*1) + (event.target.attributes.getNamedItem('hour').value * 60 * 60) + (event.target.attributes.getNamedItem('minute').value * 60);
            
            this.setState({
                videoPlayFrom: second,                
                shareHolderSlide: event.target.src,
                renderSlider: false
            });

        }
        
    }

    OnClickVideoPlay=(event)=>{

        let second = (event.target.attributes.getNamedItem('second').value*1) + (event.target.attributes.getNamedItem('hour').value * 60 * 60) + (event.target.attributes.getNamedItem('minute').value * 60);
        
        this.setState({
            videoPlayFrom: 0,
            renderSlider: false
        });
        
        this.setState({
            videoPlayFrom: second,
            renderSlider: false
        });
        
    }    

    slideBySeconds = (sec) => {
        
        let currentTime = Math.round(sec.currentTime);

        if(document.getElementById("checkSlideMatchTime"+currentTime)){

            document.getElementById("BigImage").src = document.getElementById("checkSlideMatchTime"+currentTime).src;

        }
        
    }

    imageClick = (event) => {
        let dataImg = document.getElementById('BigImage').src;
        this.setState({
            bigImageClick: dataImg,
            renderSlider: false
        });

        // console.log(document.getElementById('BigImage').src);
        // document.getElementById('img01').src = dataImg;
    }    

    render() {
        
        return (
            <>
                <div className="col-md-12 main section  no-sm-h-padding">
                    <div className="row mb-1">

                        {localStorage.programId == 'fe150217-61af-4e2a-8a84-68feb2d66cde' 
                        ?

                            <div className="video-blog-long col-lg-8 col-md-8 col-sm-12" id="aci_program">

                                <BroadCastVideo slideBySeconds={this.slideBySeconds} videoPlayFrom={this.state.videoPlayFrom} />
                                                                                
                            </div> 
                        :
                            <>
                            {localStorage.bracBankRequiredLogin === '1' 
                            ?
                                <>

                                    <div className="col-xl-8 offset-xl-2 col-lg-12 col-md-12 col-sm-12">
                                        <div className="row">
                                            <div className="video-blog-long col-lg-7 col-md-7 col-sm-12 mb-3" id="aci_program">

                                                <BroadCastVideo slideBySeconds={this.slideBySeconds} videoPlayFrom={this.state.videoPlayFrom} />
                                                                                            
                                            </div> 
                                            <div className="col-lg-5 col-md-5 col-sm-12 mb-3"> 
                                                <div className="col-lg-12 col-md-12 col-sm-12 p-0">  
                                                    
                                                    <div className="login-sec row m0">

                                                        {localStorage.downloadPresentationStatus == 1 &&
                                                            <div className="col-md-12">                                        
                                                                <a href={localStorage.downloadPresentationLink} className={`btn btn-success btn-block btn-download btn-round mb-2`} style={{background: localStorage.downloadBtnBgColor, color:localStorage.downloadBtnTextColor}} target="_blank" >
                                                                    <i className="fas fa-download"></i> Download Presentation
                                                                </a>                                        
                                                            </div>
                                                        }

                                                    </div>
                                                </div> 

                                                {this.props.isLogin &&

                                                <Comment 
                                                    chatBlockShow={this.state.chatBlockShow}
                                                    isLogin={this.props.isLogin}
                                                    comments={this.state.comments}
                                                />
                                                
                                                }        
                                            </div>
                                        </div>
                                    </div>
                                
                                </>

                                :
                                <>

                                    <div className="col-lg-9 col-md-9 col-sm-12 mb-1 p-0">
                                        <div className="col-md-12">   
                                            <div className="row"> 
                                                {/* <div className="col-md-5 col-sm-6 video-blog mb-2"> */}
                                                
                                                <div className={`${localStorage.programSpeakerStatus == 1 ? "video-blog" : "video-blog-long"} col-lg-5 col-md-5 col-sm-6 mb-2`}>

                                                    <BroadCastVideo slideBySeconds={this.slideBySeconds} videoPlayFrom={this.state.videoPlayFrom} />
                                                    
                                                    { localStorage.programSpeakerStatus == 1 &&
                                                        <Speaker speaker={this.state.speaker} OnClickVideoPlay={this.OnClickVideoPlay} />
                                                    }
                                                                                                    
                                                </div>                                        

                                                <div className="col-md-7 col-sm-6 mb-2 md-no-padding"> 

                                                    <div className="presentation-img">
                                                        {this.state.shareHolderSlide &&
                                                        <>
                                                            <span onClick={this.imageClick} src={`${this.state.shareHolderSlide}`} data-toggle="modal" data-target="#imgModal" className="viewIcon"><i className='fas fa-eye' id="BigImageView"></i> VIEW</span>

                                                            <img src={`${this.state.shareHolderSlide}`} alt="Presentation Slide" className="w100" id="BigImage" onClick={this.imageClick} data-toggle="modal" data-target="#imgModal" />  
                                                        </>
                                                        }
                                                    </div>
                                                    
                                                </div>

                                                <div className="col-md-12 col-sm-12 mt-2 p-0 ">
                                                    <AllSlide renderSlider={this.state.renderSlider} allSlide={this.state.allSlide} clickSlider={this.OnChangeBigSlider} />                                            
                                                </div>
                                
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-12 mb-2 p-0"> 
                                        <div className="col-lg-12 col-md-12 col-sm-12 p-0">  
                                            
                                            <div className="login-sec row m0">

                                                {localStorage.downloadPresentationStatus == 1 &&
                                                    <div className="col-md-12">                                        
                                                        <a href={localStorage.downloadPresentationLink} className={`btn btn-success btn-block btn-download btn-round mb-2`} style={{background: localStorage.downloadBtnBgColor, color:localStorage.downloadBtnTextColor}} target="_blank" >
                                                            <i className="fas fa-download"></i> Download Presentation
                                                        </a>                                        
                                                    </div>
                                                }

                                            </div>
                                        </div> 

                                        {this.props.isLogin &&

                                        <Comment 
                                            chatBlockShow={this.state.chatBlockShow}
                                            isLogin={this.props.isLogin}
                                            comments={this.state.comments}
                                        />
                                        
                                        }        
                                    </div>
                                
                                </>

                            }
                            </>
                        }
                        
                    </div>
                </div>

                {/* <!-- Main Section end --> */}
                
                {localStorage.noticeStatus == 1 &&
                
                    <div>
                        <button id="noticeOpen" className="d-none" data-toggle="modal" data-target="#noticeModal"></button>
                        
                        <div className="modal fade" id="noticeModal">
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="text-center">Notice</h5>
                                        <button type="button" className="close" data-dismiss="modal">&times;</button>
                                    </div>                                    
                                    <div className="modal-body">                                        
                                        <p dangerouslySetInnerHTML={{ __html: localStorage.noticeText }}></p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        
                    </div>
                

                }


                <div id="imgModal" className="modal fade" >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span className="sr-only">Close</span></button>   
                            </div>
                            <div className="modal-body">
                                <img  src={`${this.state.bigImageClick}`} className="w100" id="img01"></img> 
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                            </div>
                        </div>                                        
                    </div>  
                </div>  
                    

            </>
        );
    }
}

export default BeforeLogin;